import React, { useState } from "react";


export default function Copy({ data }) {
  const [isCopied, setIsCopied] = useState(false);


  const handleCopy = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      // Use Clipboard API if available
      navigator.clipboard
        .writeText(data)
        .then(() => {
          setIsCopied(true); // Show checkmark icon
          setTimeout(() => {
            setIsCopied(false); // Hide checkmark after 1 second
          }, 1000);
        })
        .catch((err) => {
          console.error("Failed to copy:", err);
          alert("Failed to copy to clipboard. Please try again.");
        });
    } else {
      // Fallback for older browsers that do not support Clipboard API
      const textArea = document.createElement("textarea");
      textArea.value = data;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy"); // Attempt to use legacy copy command
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1000);
      } catch (err) {
        console.error("Fallback copy failed:", err);
        alert("Unable to copy to clipboard. Please try again.");
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <span
      className="ms-2 text-secondary"
      style={{ cursor: "pointer", fontSize: "1.2rem" }}
      onClick={handleCopy}
    >
      {isCopied ? (
        <i className="bi bi-check text-success" aria-hidden="true" />
      ) : (
        <i className="bi bi-clipboard" aria-hidden="true" />
      )}
    </span>
  );
}
